/**
 * This array contains the statutes map to matching trip status type.
 */

export const statuses = [
  {
    id: 1,
    tripstatuscode: 'PROPOSAL',
    tripstatuscategory: 'ACTIVE',
    type: 'warning',
    customClass: '',
    size: 'medium',
    tripstatusname: 'Proposal'
  },
  {
    id: 2,
    tripstatuscode: 'CONFIRMED',
    tripstatuscategory: 'ACTIVE',
    type: 'default',
    customClass: 'MuiChip-colorIndigo',
    size: 'medium',
    tripstatusname: 'Confirmed'
  },
  {
    id: 3,
    tripstatuscode: 'ACTIVE',
    tripstatuscategory: 'ACTIVE',
    type: 'success',
    customClass: '',
    size: 'medium',
    tripstatusname: 'Active'
  },
  {
    id: 4,
    tripstatuscode: 'TRAVELING',
    tripstatuscategory: 'ACTIVE',
    type: 'success',
    customClass: 'MuiChip-colorIndigo',
    size: 'medium',
    tripstatusname: 'Traveling'
  },
  {
    id: 5,
    tripstatuscode: 'COMPLETE',
    tripstatuscategory: 'INACTIVE',
    type: 'default',
    customClass: 'MuiChip-colorPurple',
    size: 'medium',
    tripstatusname: 'Complete'
  },
  {
    id: 6,
    tripstatuscode: 'CANCELLED',
    tripstatuscategory: 'INACTIVE',
    type: 'error',
    customClass: '',
    size: 'medium',
    tripstatusname: 'Cancelled'
  },
  {
    id: 7,
    tripstatuscode: 'ARCHIVED',
    tripstatuscategory: 'INACTIVE',
    type: 'default',
    customClass: 'MuiChip-colorGrey',
    size: 'medium',
    tripstatusname: 'Archived'
  },

  {
    id: 8,
    tripstatuscode: 'DEFAULT',
    tripstatuscategory: 'ACTIVE',
    type: 'default',
    customClass: 'MuiChip-colorIndigo',
    size: 'medium',
    tripstatusname: 'Default'
  }
];
